import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "var(--bg-secondary)",
      padding: "2rem",
    }}>
      <div style={{
        textAlign: "center",
        maxWidth: 500,
        width: "100%",
      }}>
        <div style={{ fontSize: "5rem", marginBottom: "1rem" }}>🔍</div>
        <h1 style={{
          fontSize: "3rem",
          fontWeight: 800,
          color: "var(--text-primary)",
          margin: "0 0 0.5rem 0",
          letterSpacing: "-0.02em",
        }}>404</h1>
        <p style={{
          fontSize: "1rem",
          color: "var(--text-secondary)",
          margin: "0 0 0.5rem 0",
        }}>Page not found</p>
        <p style={{
          fontSize: "0.85rem",
          color: "var(--text-muted)",
          margin: "0 0 2rem 0",
          lineHeight: 1.6,
        }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" style={{
          display: "inline-block",
          padding: "0.75rem 2rem",
          borderRadius: "var(--radius-sm)",
          background: "var(--gradient-card)",
          color: "#fff",
          textDecoration: "none",
          fontWeight: 700,
          fontSize: "0.9rem",
          transition: "opacity 0.2s",
        }}>Back to Home</Link>
      </div>
    </div>
  );
};

export default NotFound;